import { render } from "./PreSeasonTeamEditDialog.vue?vue&type=template&id=338a88a0&scoped=true"
import script from "./PreSeasonTeamEditDialog.vue?vue&type=script&lang=js"
export * from "./PreSeasonTeamEditDialog.vue?vue&type=script&lang=js"

import "./PreSeasonTeamEditDialog.vue?vue&type=style&index=0&id=338a88a0&lang=css&scoped=true"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338a88a0"]])

export default __exports__